import { render } from "./CreateAccountPage.vue?vue&type=template&id=34048944&scoped=true"
import script from "./CreateAccountPage.vue?vue&type=script&lang=js"
export * from "./CreateAccountPage.vue?vue&type=script&lang=js"

import "./CreateAccountPage.vue?vue&type=style&index=0&id=34048944&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34048944"]])

export default __exports__